import {useNavigate} from "react-router-dom";
import {MainFrame} from "./MainFrame";



import './App.css';


export function App() {
    const navigate = useNavigate();
    const userID = "getUserID()";

    return (
        <MainFrame key={"UserID" + userID}
                   navigate={navigate}
                   displayMessage={() => {}}
        />
    );
}
export default App;
